import * as Types from '../types';

import gql from 'graphql-tag';
export type LegacyLiveBetFragment = { __typename?: 'LiveBet', id: string, actor: string, amount: string, status: Types.BetStatus, potentialPayout: string, payout?: string | null, result?: Types.BetResult | null, odds: string, settledOdds?: string | null, redeemedTxHash?: string | null, affiliate?: string | null, isRedeemed: boolean, isRedeemable: boolean, isCashedOut: boolean, tokenId: string, createdAt: string, resolvedAt?: string | null, txHash: string, redeemedAt?: string | null, core: { __typename?: 'CoreContract', address: string, liquidityPool: { __typename?: 'LiquidityPoolContract', address: string } }, selections: Array<{ __typename?: 'LiveSelection', odds: string, result?: Types.SelectionResult | null, outcome: { __typename?: 'LiveOutcome', outcomeId: string, condition: { __typename?: 'LiveCondition', conditionId: string, status: Types.ConditionStatus, gameId: string, wonOutcomeIds?: Array<string> | null } } }>, cashout?: { __typename?: 'Cashout', payout: string } | null };

export const LegacyLiveBetFragmentDoc = gql`
    fragment LegacyLiveBet on LiveBet {
  id
  tokenId: betId
  actor
  amount
  status
  potentialPayout
  payout
  result
  odds
  settledOdds
  createdAt: createdBlockTimestamp
  resolvedAt: resolvedBlockTimestamp
  txHash: createdTxHash
  redeemedTxHash
  redeemedAt: redeemedBlockTimestamp
  affiliate
  isRedeemed
  isRedeemable
  isCashedOut
  core {
    address
    liquidityPool {
      address
    }
  }
  selections {
    odds
    result
    outcome {
      outcomeId
      condition {
        conditionId
        status
        gameId
        wonOutcomeIds
      }
    }
  }
  cashout {
    payout
  }
}
    `;